document.addEventListener('DOMContentLoaded', () => {

    const bookingButtons = document.querySelectorAll('.cta-to-book');

    if (!bookingButtons.length) {
        return;
    }


    bookingButtons.forEach((button) => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            const productHandle = this.dataset.productHandle;
            const collectionHandle = this.dataset.collectionHandle;
            const productData = {
                id: this.dataset.productId,
                title: this.dataset.productTitle,
                price: this.dataset.productPrice,
                sku: this.dataset.productSku,
            };


            if (!productHandle || !collectionHandle) {
                console.error('Données produit ou collection manquantes');
                return;
            }

            fetch(`/collections/${collectionHandle}/products/${productHandle}?section_id=section-ds-popup-booking-studio`)
                .then((response) => response.text())
                .then((html) => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;

                    const bookingPopupContent = tempDiv.querySelector('#shopify-section-section-ds-popup-booking-studio');

                    if (!bookingPopupContent) {
                        console.error('Contenu de la popup non trouvé');
                        return;
                    }


                    document.body.insertAdjacentHTML('beforeend', bookingPopupContent.innerHTML);
                    let bookingManager = new BookingManagerPopup(productData);

                    const popup = document.getElementById('bookingPopup');
                    if (popup) {
                        popup.classList.remove('tw-hidden');
                        document.body.style.overflow = 'hidden';

                        const closePopup = () => {
                            popup.classList.add('tw-hidden');
                            document.body.style.overflow = '';
                            document.removeEventListener('keydown', handleEscapeKey);
                            document.removeEventListener('click', handleOutsideClick);
                            popup.remove();
                        };
                        const handleEscapeKey = (event) => {
                            if (event.key === 'Escape') {
                                closePopup();
                            }
                        };
                        const handleOutsideClick = (event) => {
                            if (
                                event.target === popup ||
                                event.target.hasAttribute('data-close') ||
                                event.target.closest('[data-close]')
                            ) {
                                closePopup();
                            }
                        };
                        document.addEventListener('keydown', handleEscapeKey);
                        popup.addEventListener('click', handleOutsideClick);
                        const closeButton = popup.querySelector('[data-close]');
                        if (closeButton) {
                            closeButton.addEventListener('click', (e) => {
                                e.stopPropagation();
                                closePopup();
                            });
                        }
                    } else {
                        console.error('Élément popup non trouvé après injection');
                    }
                })
                .catch((error) => console.error('Erreur:', error));
        });
    });
});